import {hasAnyPermission, hasPermission} from './auth';

/** 管理端登录后默认首页：按权限优先级，取用户能进的第一个页面 */
const LANDING_CANDIDATES: { permission: string; path: string }[] = [
  { permission: 'DASHBOARD_MANAGE', path: '/dashboard/operations' },
  { permission: 'RISK_REPORT_MANAGE', path: '/risk-control/reports' },
  { permission: 'PLATFORM_PRODUCT_MANAGE', path: '/product/platform/list' },
  { permission: 'MERCHANT_PRODUCT_MANAGE', path: '/product/merchant/list' },
  { permission: 'LONG_RENT_PLATFORM_PRODUCT_MANAGE', path: '/product/long-rent-platform/list' },
  { permission: 'LONG_RENT_MERCHANT_PRODUCT_MANAGE', path: '/product/long-rent-merchant/list' },
  { permission: 'ORDER_MANAGE', path: '/order/list' },
  { permission: 'OFFLINE_ORDER_MANAGE', path: '/order/offline' },
  { permission: 'AFTER_SALE_MANAGE', path: '/order/aftersalelist' },
  { permission: 'COMPLAINT_MANAGE', path: '/order/complaint' },
  { permission: 'STORE_MANAGE', path: '/store' },
  { permission: 'RECYCLE_QUALIFICATION_MANAGE', path: '/recycle/orders' },
];

export function getDefaultLandingPath(): string {
  for (const candidate of LANDING_CANDIDATES) {
    if (hasPermission(candidate.permission)) {
      return candidate.path;
    }
  }
  if (hasAnyPermission(['CATEGORY_MANAGE', 'BRAND_MANAGE', 'TAG_MANAGE', 'PRODUCT_MODEL_MANAGE', 'SPECIFICATION_MANAGE'])) {
    return '/product/category';
  }
  return '/dashboard';
}
